module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('div', {
    staticClass: "additional-page"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.pageObject.title),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "title", $$v)
      },
      expression: "pageObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.pageObject.url),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "url", $$v)
      },
      expression: "pageObject.url"
    }
  })], 1), _vm._v(" "), _c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст информации"
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "slug-url"
  }, [_c('strong', [_vm._v("Ссылка на страницу: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.pageUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.pageUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('div', {
    staticClass: "button save-content",
    on: {
      "click": function($event) {
        return _vm.saveAdditionalPage(_vm.pageObject)
      }
    }
  }, [_vm._v("СОХРАНИТЬ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns bottom-container"
  }, [(!_vm.page.isNew) ? _c('div', {
    staticClass: "column delete-service is-one-third",
    on: {
      "click": function($event) {
        return _vm.deleteAdditionalPage(_vm.page.id)
      }
    }
  }, [_c('span', [_vm._v("Удалить")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column hide"
  }, [_c('b-switch', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.pageObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.pageObject, "isHidden", $$v)
      },
      expression: "pageObject.isHidden"
    }
  }, [_vm._v("Скрыть страницу")])], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2b14eac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdditionalPages/AdditionalPage.vue
// module id = 993
// module chunks = 0